import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SchemaForm from '../SchemaForm'
import { Link } from 'react-router-dom'

export default class UpdateProfile extends Component {
  static propTypes = {
    onSubmit: PropTypes.func
  }

  render () {
    const schema = {
      name: {type: 'string', required: true}
    }

    return <div>
      <h3 className='information-header'>
        <div className='float-right'>
          <Link to='/logout'>Logout</Link>
        </div>
        Account Profile
      </h3>
      <SchemaForm schema={schema} {...this.props} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/account/UpdateProfile.js